import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"
import PopularSearchQueries from "./PopularSearchQueries"
import PopularSites from "./PopularSites"
import { useEffect } from "preact/hooks"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)

    // if (!historyItems || !historyItems.length) {
    //     return
    // }
    // useEffect(() => {
    //     const target = document.getElementById("search-initial-products");
      
    //     if (!target) {
    //       console.warn("❌ [NOSTO] #search-initial-products not found");
    //       return;
    //     }
      
    //     let hasMigratedOnce = false;
      
    //     function runMigration(source) {
    //       if (window.Nosto?.migrateToShopifyMarket) { 
    //         window.Nosto.migrateToShopifyMarket({
    //           productSectionElement: ".nosto-product-info",
    //           productUrlElement: ".nosto-product-url",
    //           productHandleAttribute: "x-nosto-handle",
    //           priceElement: ".nosto-newprice.money",
    //           listPriceElement: ".nosto-oldprice.money"
    //         });
    //       } else {
    //         console.warn(`❌ [NOSTO] migrateToShopifyMarket not available from ${source}`);
    //       }
    //     }
      
    //     // 1. Observe children rendering
    //     const contentObserver = new MutationObserver(() => {
    //       const productInfo = target.querySelector(".nosto-product-info");
    //       if (productInfo && !hasMigratedOnce) {
    //         hasMigratedOnce = true;
    //         runMigration("initial render");
    //       }
    //     });
      
    //     contentObserver.observe(target, {
    //       childList: true,
    //       subtree: true,
    //     });
      
    //     // 2. Observe style/class changes to detect visibility
    //     const visibilityObserver = new MutationObserver(() => {
    //       const style = window.getComputedStyle(target);
    //       const isVisible = style.display !== "none";
    //       if (isVisible) {
    //         runMigration("visibility change");
    //       }
    //     });
      
    //     visibilityObserver.observe(target, {
    //       attributes: true,
    //       attributeFilter: ["style", "class"],
    //     });
      
    //     return () => {
    //       contentObserver.disconnect();
    //       visibilityObserver.disconnect();
    //     };
    //   }, []);      

    return (
        <div class="flex-1 overflow-hidden">
            <div class="w-full">
                <div class="searchGrid lg:mb-12">
                    <div class="flex gap-8 pb-48 pt-24 px-12 lg:col-span-full lg:px-0 lg:gap-12">
                        <div class="w-1/2">
                            <div className="mb-6">
                                <PopularSearchQueries/>
                            </div>
                        </div>

                        <div class="w-1/2 lg:pr-24">
                            <PopularSites />
                        </div>
                    </div>

                    <div class="relative px-12 overflow-y-auto lg:col-span-full lg:flex lg:flex-col lg:px-0">
                        <div class="flex flex-col lg:flex-row lg:flex-wrap">  
                            <div class="nosto_element" id="search-initial-products"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
